const TableNoData = ({ columnDefs, noDataText }) => (
  <tr>
    <td colSpan={columnDefs.length} className="px-4 py-2 text-center text-neutral-400">
      {noDataText}
    </td>
  </tr>
);

export default TableNoData;
